import { Controller } from "@hotwired/stimulus"

export default class EmojiMartController extends Controller {
  static targets = ['picker', 'quillInput', 'emojiToggle', 'showEmoji']

  connect() {
    this.loadEmojiMart()
    this.handlePickerClick = this.handlePickerClick.bind(this)

    if (this.hasPickerTarget) {
      this.setupPicker()
      this.pickerTarget.addEventListener("click", this.handlePickerClick)
    }
  }

  async loadEmojiMart() {
    if (this.emojiPromise) return this.emojiPromise

    this.emojiPromise = Promise.all([
      import("../emoji_mart/emoji-mart-data"),
      import("../emoji_mart/emoji-mart")
    ])

    return this.emojiPromise
  }

  disconnect() {
    if (this.hasPickerTarget) {
      this.pickerTarget.removeEventListener("click", this.handlePickerClick)
    }
    window.removeEventListener("scroll", this.onScroll, true)
    this.pickerInstance?.remove?.()
    this.pickerInstance = null
    this.quillInstance = null
  }

  handlePickerClick(event) {
    event.stopPropagation()
  }

  get emojiApiUrl() {
    return this.element.dataset.emojiUrl
  }

  get quill() {
    if (this.quillInstance) return this.quillInstance
    if (!this.hasQuillInputTarget) return null

    const controller = this.application.getControllerForElementAndIdentifier(
      this.quillInputTarget,
      "quill"
    )

    this.quillInstance = controller?.quill || null
    return this.quillInstance
  }

  getEmojiUrl(unified) {
    return `https://emoji.itoons.com/emojis/${String(unified).toLowerCase()}.png`
  }

  async setupPicker() {
    if (!this.hasPickerTarget) return
    const [dataModule, emojiMart] = await this.loadEmojiMart()

    const data = dataModule.default
    const { Picker } = emojiMart

    // Prevent duplicate (Turbo fix)
    this.pickerTarget.innerHTML = ''
    if (this.hasEmojiToggleTarget) {
      this.emojiArray = []
      if(this.hasShowEmojiTarget){
          this.emojiArray = JSON.parse($(this.showEmojiTarget).attr('data-exist-emoji'))
      }
    }  

    this.pickerInstance = new Picker({
      data: data,
      getSpritesheetURL: () => 'https://emoji.itoons.com/emoji.png',
      set: 'facebook',
      native: false,
      sheetSize: 64,
      onEmojiSelect: (emoji) => this.handleEmojiSelect(emoji),
      perLine: 6,
      emojiSize: 30,
      emojiButtonSize: 46,
      previewPosition: 'none',
      skinTonePosition: 'none',
      navPosition: 'top',
      theme: 'none'
    })

    this.pickerTarget.appendChild(this.pickerInstance)
    this.addCloseButton()
  }

  // ✅ Handle emoji select
  handleEmojiSelect(emoji) {
    if (this.quill) {
      this.insertIntoQuill(emoji)
    } else if (this.hasEmojiToggleTarget) {
      this.emojiArray.push(emoji.unified)
      postEmojiData(this.emojiArray, $(this.element).attr('data-msg-id'))
    }
    this.element.dispatchEvent(new CustomEvent("emoji-mart:select", {bubbles: true, detail: {
      unified: emoji.unified,
      url: this.getEmojiUrl(emoji.unified),
      native: emoji.native
    }}));
  }

  insertIntoQuill(emoji) {
    const quill = this.quill
    if (!quill) return

    quill.focus()

    const range = quill.getSelection(true)
    const index = range ? range.index : quill.getLength()

    quill.insertEmbed(
      index,
      "emoji",
      {
        unified: emoji.unified,
        url: this.getEmojiUrl(emoji.unified),
        native: emoji.native
      },
      "user"
    )

    quill.setSelection(index + 1, 0, "user")
    quill.root.dispatchEvent(new Event("input", { bubbles: true }))

  }

  removeEmoji(e){
    e.preventDefault()
    this.emojiArray.splice($.inArray(e.currentTarget.dataset.emoji, this.emojiArray), 1);
    postEmojiData(this.emojiArray, $(this.element).attr('data-msg-id'))
    e.target.remove()
  }

  addCloseButton() {
    requestAnimationFrame(() => {
      const root = this.pickerInstance?.shadowRoot?.querySelector("#root")
      const button = document.getElementById("emoji-picker-close-button")
      if (!root || !button) return
      if (root.contains(button)) return

      button.onclick = (event) => {
        button.dispatchEvent(new CustomEvent("emoji-mart-dropdown:hide", { bubbles: true, composed: true }))
      }

      root.prepend(button)
    })
  }
}

function postEmojiData(emoji_array, msg_id) {
  const csrfToken = document.getElementsByName("csrf-token")[0].content;
  fetch('/messages/'+msg_id+'/save_emoji', {
    method: 'post',
    headers: {
        "X-CSRF-Token": csrfToken,
        'Content-Type': 'application/json'
    },body: JSON.stringify({emoji_array: emoji_array})
  }).then(r => r.text())
    .then(response => {
        Turbo.renderStreamMessage(response)
    })
}